import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomerHubRedirect } from './-ui/customer-hub-redirect'

// Legacy deep-link: команда компании живёт в табе «Команда» хаба заказчика
// (таб доступен только customer-admin; не-admin хаб откроет дефолтный таб).
export const Route = createFileRoute('/_app/team')({
  beforeLoad: ({ context }) => {
    if (context.session?.kind === 'employee') throw redirect({ to: '/boards' })
  },
  head: () => ({ meta: [{ title: 'Команда · STIT Deal' }] }),
  component: () => <CustomerHubRedirect tab="team" />,
})
